// Small Greek flag — authentic 9 stripes + canton cross
export const GreekFlag = ({ className = "" }) => {
  const blue = "#0D5EAF";
  const stripes = Array.from({ length: 9 });
  return (
    <svg
      viewBox="0 0 27 18"
      className={className}
      role="img"
      aria-label="Greek flag"
      style={{ display: "block", borderRadius: 2, boxShadow: "0 4px 12px -4px rgba(13,94,175,0.5)" }}
    >
      {stripes.map((_, i) => (
        <rect key={i} x="0" y={i * 2} width="27" height="2" fill={i % 2 ? "#fff" : blue} />
      ))}
      <rect x="0" y="0" width="10" height="10" fill={blue} />
      <rect x="4" y="0" width="2" height="10" fill="#fff" />
      <rect x="0" y="4" width="10" height="2" fill="#fff" />
    </svg>
  );
};
